var map = {
	"./en-EN/404.json": [
		45153
	],
	"./en-EN/account-settings.json": [
		8570,
		8570
	],
	"./en-EN/articles/article-1.json": [
		63937,
		3937
	],
	"./en-EN/blog.json": [
		5581
	],
	"./en-EN/brand-materials.json": [
		21511,
		1511
	],
	"./en-EN/common.json": [
		84848
	],
	"./en-EN/dashboard.json": [
		87813,
		7813
	],
	"./en-EN/edit-menu.json": [
		30781,
		781
	],
	"./en-EN/login.json": [
		76948
	],
	"./en-EN/order-tracking.json": [
		25771,
		5771
	],
	"./en-EN/orders.json": [
		99608,
		9608
	],
	"./en-EN/products.json": [
		48677,
		8677
	],
	"./en-EN/register.json": [
		20288
	],
	"./en-EN/request-password-reset.json": [
		10990
	],
	"./en-EN/reset-password.json": [
		46258
	],
	"./en-EN/restaurant-menu.json": [
		55048
	],
	"./en-EN/restaurant-profile.json": [
		92138,
		2138
	],
	"./en-EN/sidebar.json": [
		86037,
		6037
	],
	"./en-EN/styleguide.json": [
		95826
	],
	"./en-EN/welcome.json": [
		53541,
		3541
	],
	"./pt-PT/404.json": [
		25595,
		5595
	],
	"./pt-PT/account-settings.json": [
		83864,
		3864
	],
	"./pt-PT/articles/article-1.json": [
		19071,
		9071
	],
	"./pt-PT/blog.json": [
		25367,
		5367
	],
	"./pt-PT/brand-materials.json": [
		35005,
		5005
	],
	"./pt-PT/common.json": [
		52270,
		2270
	],
	"./pt-PT/dashboard.json": [
		52431,
		2431
	],
	"./pt-PT/edit-menu.json": [
		78691,
		8691
	],
	"./pt-PT/login.json": [
		12010,
		2010
	],
	"./pt-PT/order-tracking.json": [
		73561,
		3561
	],
	"./pt-PT/orders.json": [
		61838,
		1838
	],
	"./pt-PT/products.json": [
		95939,
		5939
	],
	"./pt-PT/register.json": [
		14454,
		4454
	],
	"./pt-PT/request-password-reset.json": [
		84704,
		4704
	],
	"./pt-PT/reset-password.json": [
		1716,
		1716
	],
	"./pt-PT/restaurant-menu.json": [
		16374,
		6374
	],
	"./pt-PT/restaurant-profile.json": [
		19972,
		9972
	],
	"./pt-PT/sidebar.json": [
		18707,
		8707
	],
	"./pt-PT/styleguide.json": [
		53288,
		3288
	],
	"./pt-PT/welcome.json": [
		69211,
		9211
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 23630;
module.exports = webpackAsyncContext;